/// FOURJS_START_COPYRIGHT(D,2021)
/// Property of Four Js*
/// (c) Copyright Four Js 2021, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT
"use strict";

/**
 * @readonly
 * @enum {string};
 */
gbc.constants.controllerEvents = {
  created: "g_created",
  detachUi: "g_detachUi",
  focusChild: "g_focusChild"
};
